import { render, staticRenderFns } from "./_base-label-select.vue?vue&type=template&id=ed57bb96"
import script from "./_base-label-select.vue?vue&type=script&lang=js"
export * from "./_base-label-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports